import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * O `twMerge` só conhece os tamanhos de fonte do Tailwind. `text-rotulo`
 * (`--text-rotulo` em `theme.css`) é TAMANHO, mas ele o lia como cor: junto de
 * `text-texto-suave` ficava a cor e o tamanho sumia, e o rótulo saía no corpo
 * herdado — maior que o título acima dele, no trilho de etapas do `Form`.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: ['rotulo'],
      /*
       * E só conhece os raios do Tailwind. `rounded-grande` não era lido como
       * raio, então `rounded-full` passado por cima NÃO o substituía: as duas
       * classes ficavam, e vencia a que o CSS declarasse por último. Medido em
       * 07/10: no pódium o avatar do 1º saiu quadrado e o 2º e o 3º redondos,
       * com o mesmo `className`.
       */
      radius: ['pequeno', 'borda', 'cartao', 'grande', 'pilula'],
    },
  },
});

export function cn(...classes: ClassValue[]): string {
  return twMerge(clsx(classes));
}
